import React from "react";
import { useTheme } from "../../context/ThemeContext";

export function TopicBadge({ label }) {
  const { t } = useTheme();
  return (
    <span style={{ background: t.tag, color: t.tagText, fontSize: 11, padding: "3px 9px", borderRadius: 20, fontWeight: 500, flexShrink: 0 }}>
      {label}
    </span>
  );
}

export function TagBadge({ label }) {
  const { t } = useTheme();
  return (
    <span style={{ background: "transparent", color: t.text3, fontSize: 11, padding: "3px 8px", border: `0.5px solid ${t.border}`, borderRadius: 20, flexShrink: 0 }}>
      {label}
    </span>
  );
}
